import { useMutation } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'

const uploadImages = async (files: File[], postId: string) => {
  const uploadedUrls: string[] = []

  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    const imageType = file.type
    const presignedUrlResponse = await postRequest<{ key: string; url: string; photoUrl: string }>(
      `/users/generate-presigned-url?file_type=${encodeURIComponent(
        imageType,
      )}&photo_type=post_photo&post_id=${postId}&index=${i}`,
      {},
    )

    const url = presignedUrlResponse?.url
    if (!url) throw new Error('Error fetching presigned URL')

    const uploadResponse = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': imageType },
    })

    if (!uploadResponse.ok) throw new Error('Error uploading image')

    uploadedUrls.push(presignedUrlResponse.photoUrl)
  }

  return uploadedUrls
}

export const useUploadImages = () => {
  return useMutation({
    mutationFn: ({ files, postId }: { files: File[]; postId: string }) => uploadImages(files, postId),
  })
}
